<template>
  <cargo-dialog
    id="app"
    :close-on-click-modal="false"
    :visible="visible"
    :title="$t('CargoMsg.Cargo_ChooseFee')"
    append-to-body
    width="1160px"
    top="5vh"
    :can-maximize="true"
    :can-minimize="source==='append'"
    @close="cancel"
  >
    <search-item
      ref="searchItem"
      :show-more-scheme="false"
      :show-simple="false"
      :expand-adv="true"
      :col-settings="{span:12}"
      :search-item-code="$t('SeaExport.AddBillCharge')"
      :config-module="searchItemModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      append-to-body
      @advSearchItemCallBack="fetchData"
    />
    <div class="section grid-wrapper" style="display:flex;flex-grow: 1">
      <cargo-ag-grid
        config-module="190905"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :grid-params.sync="gridParams"
        :row-data="rowData"
        :style="{width:'100%',height:'100%','flex-grow':1}"
      />
    </div>
    <div id="footer-wrapper" class="pagination-wrapper">
      <div style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 10px;">
        <div v-if="totalAmountToCurrencyChargeGrid.selectedCount > 0"><span>选中 {{ totalAmountToCurrencyChargeGrid.selectedCount }}：</span></div>
        <charge-currency-total-group
          v-if="reCalc"
          :amount-to-currency="localCurrency"
          data-field="chargeAmount"
          currency-field="chargeCurrency"
          rate-field="chargeRate"
          ar-field="chargeReceivable"
          type="revenueAbs"
          :data-provider="totalAmountToCurrencyChargeGrid.dataProvider"
        />
      </div>
      <cargo-pagination
        config-module="190905"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
    <div slot="footer">
      <el-button no="1" type="primary" size="mini" @click="enterEvent">{{ $t('Billing.billingView_Determine') }}</el-button>
      <el-button no="2" size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </cargo-dialog>

</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getGridSelected } from '@/utils/agGrid'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { getAddChargeList } from '@/api/clearing/billingNative'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { cacheName, cache } from '@/utils/cacheManager'
import { formatNumberToThousands } from '@/utils'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import { Once } from '@/utils/commonUtil'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'

export default {
  name: 'JoinChargeDialog',
  components: { CargoDialog, searchItem, cargoAdvanceSelect, chargeCurrencyTotalGroup, ChargeCountGroup },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultConditions: { type: Object, required: true }, // 弹框打开时默认传递条件
    jobStateParam: { type: String, default: '' },
    chargeStateParam: { type: String, default: '' },
    confirmStateParam: { type: String, default: '' },
    source: { type: String, default: '' },
    searchItemModule: { type: String, default: '5041' }
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      innerVisible: this.visible,
      searchItemAutoInit: true,
      customSearchItems: [], // 自定义高级查询项
      gridOptions: {
        rowSelection: 'multiple',
        onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        pagination: false
      },
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      defaultSearchConditions: {
        accountId: 0, // 结算对象ID
        isAr: -1, // 应收/应付
        advance: -1, //  是否垫付
        oversea: -1, // （国内/国外）
        hasInvoice: -1, // 是否开票
        hasDiffCharge: -1, // 是否关联差异对冲费用
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [], // 费用确认状态
        exceptKeys: [], // 在查询中想要例外的对象列表
        hasBillPayment: -1, // 是否关联付款申请
        hasBilling: -1, // 是否关联账单
        isShowWriteOff: -1
      },
      viewSource: 'BillingDetail_AddCharge', // 默认是账单详情加入费用
      totalAmountToCurrencyChargeGrid: { // 右下角合计组件相关参数
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [],
        chargeCountGroupDataProvider: [] // 弹出框数据源
      },
      once: new Once(this)
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'router-and-print',
            attrs: {
              useRoute: true,
              usePrint: true,
              routeName: 'FinanceManage',
              routeParamKeys: { jobNo: 'jobJobNo' },
              routeTitle: this.$t('Payment.financialAudit'),
              routePermissions: ['module_ACVerify'],
              extraRouteParams: {},
              printMethod: this.toSearchTemplate
            }
          },
          onCellClicked: (params) => {
            if (params.event.target.tagName === 'A') {
              this.cancel()
            }
          }
        },
        { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', width: 200 },
        { headerName: this.$t('Payment.bookingNo'), field: 'jobBookingNo', width: 200 },
        {
          headerName: this.$t('SeaExport.DocCutOffDate'), field: 'jobFileCutoff', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.itemNo'), field: 'jobPoNo', width: 200 },
        { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', width: 200 },
        { headerName: this.$t('Payment.containerNo'), field: 'jobContainerNo', width: 200 },
        {
          headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Payment.billPaymentNo'), field: 'billPaymentBillPaymentNo', width: 200 },
        {
          headerName: this.$t('Payment.eta'), field: 'jobEta', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.etd'), field: 'jobEtd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.billNo'), field: 'billingBillingNo', width: 200 },
        {
          headerName: this.$t('Payment.settleAccountsTo'), field: 'chargeAccountId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 200 },
        { headerName: this.$t('Payment.separateNumber'), field: 'jobImportHbl', width: 200 },
        {
          headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.businessType'), field: 'jobLob', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVesselFlight', width: 200 },
        {
          headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.departureStation'), field: 'jobDepartureStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.destinationStation'), field: 'jobDestinationStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.transitStation'), field: 'jobTransitStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('Payment.destinationAgent'), field: 'jobDestinationAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.sales'), field: 'jobSales', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.operation'), field: 'jobOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.customerService'), field: 'jobCsr', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Documents'), field: 'jobDc', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Payment.businessReferenceNumber'), field: 'jobCustomerRefNo', width: 200 },
        {
          headerName: this.$t('Payment.customJobType'), field: 'jobCustomJobType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Payment.financialDate'), field: 'chargeAccountingDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.domesticInternational'), field: 'chargeOversea', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.overseaLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.isReceivable'), field: 'chargeReceivable', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('Payment.feeStatus'), field: 'chargeChargeState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('Payment.auditor'), field: 'chargeAuditor', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.confirmationStatus'), field: 'chargeConfirmState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeConfirmStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('Payment.chargeItem'), field: 'chargeChargeItemId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('Payment.unit'), field: 'chargeMeasure', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ChargeMeasure, 'code', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 200 },
        { headerName: this.$t('Payment.quantity'), field: 'chargeQuantity', width: 200 },
        {
          headerName: this.$t('Payment.unitPrice'), field: 'chargeUnitRate', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3), 2)
          }
        },
        {
          headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmount', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
          }
        },
        {
          headerName: this.$t('Payment.taxExcludedPrice'), field: 'chargeExcludingTaxAmount', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
          }
        },
        {
          headerName: this.$t('Payment.taxAmount'), field: 'chargeTaxAmount', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.taxRate'), field: 'chargeTaxRate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.theAmountOfWriteOffs'), field: 'chargeVerifiedAmount', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
          }
        },
        {
          headerName: this.$t('Payment.amountNotWrittenOff'), field: 'chargeUnverifiedAmount', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.contactPerson'), field: 'chargeContactPerson', width: 200 },
        {
          headerName: this.$t('Payment.creator'), field: 'chargeCreatedBy', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.dateOfCreation'), field: 'chargeDateCreated', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.remarks'), field: 'chargeRemarks', width: 200 },
        { headerName: this.$t('Payment.relatedJob'), field: 'jobRelatedJob', width: 200 },
        { headerName: this.$t('Payment.trustFromJob'), field: 'jobTrustFromJob', width: 200 },
        {
          headerName: this.$t('Payment.carrierId'), field: 'jobCarrierId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.confirmDate'), field: 'chargeConfirmDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.confirmUser'), field: 'chargeConfirmUser', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.planner'), field: 'jobPlanner', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Payment.moneyWriteOffStatus'), field: 'realClearingState',
          cellRenderer: (params) => {
            return ColumnUtils.realClearingStateLabFun(params.value)
          }, width: 100 },
        {
          headerName: this.$t('Payment.invoiceDateAll'), field: 'invoiceInvoiceDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Payment.invoiceNo'), field: 'chargeInvoiceNo', width: 200 },
        { headerName: this.$t('Payment.invoiceHeader'), field: 'chargeInvoiceTitle', width: 200,
          cellRenderer: (params) => {
            return params.data.chargeInvoiceTitle
          }
        },
        {
          headerName: this.$t('Payment.isNeedInvoice'), field: 'chargeNeedInvoice', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Payment.confirmRemarks'), field: 'chargeConfirmRemarks', width: 200 },
        {
          headerName: this.$t('Payment.writeOffDate'), field: 'chargeClearingDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.businessStatus'), field: 'jobJobState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.jobStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', width: 200 },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', width: 200 },
        {
          headerName: this.$t('Payment.payReceiveDate'), field: 'chargePayReceiveDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.SalesDepartment'), field: 'jobSalesDepartment', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementAgent'), field: 'chargeSettlementAgentId', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessModel'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          cellRenderer: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunctionForAllBusiness(params.data, 'containerLoadType')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunctionForAllBusiness(params.data, 'containerLoadType')
          },
          hide: true,
          width: 150
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedContainerNo'),
          field: 'chargeRelationContainerNo',
          colId: 'chargeRelationContainerNo',
          width: 200,
          hide: true
        }

      ]
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    const defaultConditions = this.defaultConditions
    const defaultSearchConditions = this.defaultSearchConditions
    if (defaultConditions.hasOwnProperty('viewSource')) {
      this.viewSource = defaultConditions.viewSource
    }
    if (defaultConditions.hasOwnProperty('accountId')) {
      defaultSearchConditions.accountId = defaultConditions.accountId
    }
    if (defaultConditions.hasOwnProperty('settlementAgentId')) {
      defaultSearchConditions.settlementAgentId = defaultConditions.settlementAgentId
    }
    if (defaultConditions.hasOwnProperty('isAr')) {
      defaultSearchConditions.isAr = defaultConditions.isAr
    }
    if (defaultConditions.hasOwnProperty('advance')) {
      defaultSearchConditions.advance = defaultConditions.advance
    }
    if (defaultConditions.hasOwnProperty('oversea')) {
      defaultSearchConditions.oversea = defaultConditions.oversea
    }
    if (defaultConditions.hasOwnProperty('hasInvoice')) {
      defaultSearchConditions.hasInvoice = defaultConditions.hasInvoice
    }
    if (defaultConditions.hasOwnProperty('hasDiffCharge')) {
      defaultSearchConditions.hasDiffCharge = defaultConditions.hasDiffCharge
    }
    if (defaultConditions.hasOwnProperty('jobStates')) {
      defaultSearchConditions.jobStates = defaultConditions.jobStates
    }
    if (defaultConditions.hasOwnProperty('chargeStates')) {
      defaultSearchConditions.chargeStates = defaultConditions.chargeStates
    }
    if (defaultConditions.hasOwnProperty('confirmStates')) {
      defaultSearchConditions.confirmStates = defaultConditions.confirmStates
    }
    if (defaultConditions.hasOwnProperty('exceptKeys')) {
      defaultSearchConditions.exceptKeys = defaultConditions.exceptKeys
    }
    if (defaultConditions.hasOwnProperty('hasBillPayment')) {
      defaultSearchConditions.hasBillPayment = defaultConditions.hasBillPayment
    }
    if (defaultConditions.hasOwnProperty('hasBilling')) {
      defaultSearchConditions.hasBilling = defaultConditions.hasBilling
    }
    if (defaultConditions.hasOwnProperty('currency')) {
      defaultSearchConditions.currency = defaultConditions.currency
    }
    // 默认高级查询条件
    const defaultSearchFields = []
    if (defaultSearchConditions.accountId > 0 || defaultSearchConditions.settlementAgentId > 0) {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(defaultSearchConditions.accountId))
      const settlementAgent = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(defaultSearchConditions.settlementAgentId))
      if (company || settlementAgent) {
        // 结算对象
        let searchField = new AdvancedSearchField()
        if (!this.defaultConditions.createBillWay || this.defaultConditions.createBillWay === 0) {
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.defaultValue = defaultSearchConditions.accountId
          searchField.action = AdvancedSearchField.UPDATE_ACTION
        } else if (this.defaultConditions.createBillWay === 1) {
          searchField.itemType = 'company'
          searchField.lock = false
          searchField.defaultValue = []
        }
        searchField.multiple = 0
        searchField.itemLabel = 'Billing.billingJob_settlementCompany'
        searchField.itemName = 'charge.ACCOUNT_ID'
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.defaultSelected = 1
        searchField.selected = 1
        defaultSearchFields.push(searchField.formatObj2Json())
        // 结算代理
        searchField = new AdvancedSearchField()
        if ((this.defaultConditions.createBillWay && this.defaultConditions.createBillWay === 1) || this.defaultConditions.limitSettlementAgent) {
          const options = [{ code: settlementAgent.cmpIdx, chineseName: settlementAgent.chineseName, englishName: settlementAgent.englishName }]
          searchField.itemType = 'select'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.defaultValue = defaultSearchConditions.settlementAgentId
          searchField.action = AdvancedSearchField.UPDATE_ACTION
        } else if (!this.defaultConditions.createBillWay || this.defaultConditions.createBillWay === 0) {
          searchField.itemType = 'company'
          searchField.lock = false
          searchField.defaultValue = []
        }
        searchField.multiple = 0
        searchField.itemLabel = 'CargoMsg.Cargo_SettlementAgent'
        searchField.itemName = 'charge.SETTLEMENT_AGENT_ID'
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.defaultSelected = 1
        searchField.selected = 1
        defaultSearchFields.push(searchField.formatObj2Json())
      }
    }
    if (defaultSearchConditions.oversea > -1) {
      const searchField = new AdvancedSearchField()
      // searchField.itemType = 'select'
      searchField.multiple = 0
      searchField.defaultValue = !!defaultSearchConditions.oversea
      searchField.itemLabel = 'Billing.billingCharge_domesticOrInternational'
      searchField.itemName = 'charge.OVERSEA'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.lock = true
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    if (defaultSearchConditions.currency) {
      const searchField = new AdvancedSearchField()
      searchField.action = 0
      searchField.itemType = 'currency'
      searchField.fieldType = 'FIELD_CURRENCY'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.itemName = 'charge.CURRENCY'
      searchField.itemLabel = 'Payment.currency'
      searchField.itemValue = ''
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.valueExpression = ''
      searchField.lock = true
      searchField.defaultValue = defaultSearchConditions.currency
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    // 业务状态配置项
    const billingJobStates = await LoadDefaultQueryParam.getConfigQueryParam(this.jobStateParam, SystemConstants.JOB_STATES) // BillingJobState cargo 未传此参数
    if (billingJobStates && billingJobStates.length > 0) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.defaultValue = []
      searchField.itemLabel = 'Billing.billingCharge_businessStatus'
      searchField.itemName = 'job.JOB_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = billingJobStates
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    // 费用状态配置项
    const billingChargeStates = await LoadDefaultQueryParam.getConfigQueryParam(this.chargeStateParam, ChargeConstants.CHARGE_STATES)
    if (billingChargeStates && billingChargeStates.length > 0) {
      const chargeAuditFlow = Number(cache.config.get('chargeAuditFlow')) === 1
      if (!chargeAuditFlow) {
        for (let i = 0; i < billingChargeStates.length; i++) {
          const chargeState = billingChargeStates[i]
          if (chargeState.code === ChargeConstants.STATE_REJECT.code) {
            billingChargeStates.splice(i, 1)
            break
          }
        }
      }
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.defaultValue = []
      searchField.itemLabel = 'Billing.billingCharge_feeStatus'
      searchField.itemName = 'charge.CHARGE_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = billingChargeStates
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    // 费用确认状态配置项
    const billingChargeConfirmStates = await LoadDefaultQueryParam.getConfigQueryParam(this.confirmStateParam, ChargeConstants.CONFIRM_STATES)
    if (billingChargeConfirmStates && billingChargeConfirmStates.length > 0) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.defaultValue = []
      searchField.itemLabel = 'Billing.billingCharge_confirmStatus'
      searchField.itemName = 'charge.CONFIRM_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = billingChargeConfirmStates
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    // CARGO-47116 加入费用添加业务模式
    const searchField = new AdvancedSearchField()
    searchField.itemType = 'containerLoadTypeCascader'
    searchField.fieldType = 'FIELD_DROP_DOWN_LIST_ALL_LOB'
    searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
    searchField.defaultConditionVal = 'IN'
    searchField.itemName = 'containerLoadTypeForAll'
    searchField.itemLabel = 'CargoMsg.Cargo_BusinessModel'
    searchField.defaultValue = []
    searchField.action = AdvancedSearchField.ADD_ACTION
    defaultSearchFields.push(searchField.formatObj2Json())

    if (this.defaultConditions.instructionCode) {
      searchField.itemType = 'select'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
      searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_EQUAL.code
      searchField.itemName = 'charge.ACCOUNT_RECEIVABLE'
      searchField.itemLabel = 'Payment.receivablesAndPayables'
      searchField.dataProvider = ChargeConstants.RECEIVABLE_PAYABLE_TYPES
      searchField.defaultSelected = 1
      searchField.selected = 1
      if (this.defaultConditions.instructionCode === 'domesticPay') {
        searchField.defaultValue = false
        searchField.lock = true
      } else if (this.defaultConditions.instructionCode === 'domesticReceivable') {
        searchField.defaultValue = true
        searchField.lock = true
      } else {
        searchField.defaultValue = ''
      }
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    if (defaultSearchFields.length > 0) {
      this.customSearchItems = defaultSearchFields
      this.searchItemAutoInit = true
    }
    this.setLocalCurrency()
  },
  beforeMount() {
  },
  methods: {
    cancel() {
      this.resetResult()
      this.$emit('leavePage')
      this.$emit('update:visible', false)
    },
    resetResult() {
      this.rowData = []
      this.searchConditions.total = 0
      this.totalAmountToCurrencyChargeGrid.dataProvider = []
      this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = []
      this.totalAmountToCurrencyChargeGrid.selectedCount = 0
    },
    fetchData(conditions) {
      this.searchConditions.snapshotConditions = [...conditions]
      this.searchConditions.pageNum = 1
      this.toAdvQueryList(conditions)
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    async toAdvQueryList(conditions) {
      this.loading = getLoading()
      // 结算类型中的this.$t('Message.Monthly')是按照大于1来判断的，不能用等于
      for (let i = 0; i < conditions.length; i++) {
        const condition = conditions[i]
        if (condition.fieldType === 'settlementType' && condition.value === 1) {
          condition.operator = OperatorConstants.OPERATOR_GREATER.code
          break
        }
      }
      const defaultSearchConditions = this.defaultSearchConditions
      // 应收/应付
      if (defaultSearchConditions.isAr !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', defaultSearchConditions.isAr === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      // 是否垫付
      if (defaultSearchConditions.advance !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ADVANCE', defaultSearchConditions.advance === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }

      // 是否开票
      if (defaultSearchConditions.hasInvoice !== -1) {
        const operator = defaultSearchConditions.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, operator)
        conditions.push(condition.formatObj2Json())
      }
      // 红冲状态
      const condition = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
      // 是否关联差异对冲费用
      if (defaultSearchConditions.hasDiffCharge !== -1) {
        const operator = defaultSearchConditions.hasDiffCharge === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        conditions.addItem(new AdvancedSearchOption(null, 'charge.DIFF_CHARGE_UUID', null, operator))
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
        let jobStates = []
        const billingJobState = await LoadDefaultQueryParam.getConfigQueryParam(this.jobStateParam, SystemConstants.JOB_STATES) // BillingJobState cargo 未传此参数
        if (billingJobState) {
          jobStates = LoadDefaultQueryParam.convertCommonStateToInt(billingJobState)
          const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用状态
      if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', conditions)) {
        let chargeStates = []
        const billingChargeState = await LoadDefaultQueryParam.getConfigQueryParam(this.chargeStateParam, ChargeConstants.CHARGE_STATES) // BillingChargeState
        if (billingChargeState) {
          chargeStates = LoadDefaultQueryParam.convertCommonStateToInt(billingChargeState)
          const condition = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用确认状态
      if (!AdvancedSearchOption.hasField('charge.CONFIRM_STATE', conditions)) {
        let confirmStates = []
        const billingChargeConfirmState = await LoadDefaultQueryParam.getConfigQueryParam(this.confirmStateParam, ChargeConstants.CONFIRM_STATES)
        if (billingChargeConfirmState) {
          confirmStates = LoadDefaultQueryParam.convertCommonStateToInt(billingChargeConfirmState)
          const condition = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', confirmStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 在查询中想要例外的对象列表
      if (defaultSearchConditions.exceptKeys.length > 0) {
        const condition = new AdvancedSearchOption(null, 'charge.UUID', defaultSearchConditions.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        conditions.push(condition.formatObj2Json())
      }
      // 是否做过付款申请
      if (defaultSearchConditions.hasBillPayment !== -1) {
        const operator = defaultSearchConditions.hasBillPayment === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.BILL_PAYMENT_UUID', null, operator)
        conditions.push(condition.formatObj2Json())
      }
      // 是否做过账单
      if (defaultSearchConditions.hasBilling !== -1) {
        const operator = defaultSearchConditions.hasBilling === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.BILLING_UUID', null, operator)
        conditions.push(condition.formatObj2Json())
      }

      // 是否显示  0 不勾选 1勾选已核销
      if (defaultSearchConditions.isShowWriteOff !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.PAID_OFF', defaultSearchConditions.isShowWriteOff, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      // 默认条件是否有分公司id
      let currentBillingBranchId = this.$store.getters.currentOfficeId
      if (this.defaultConditions.currentBillingBranchId) {
        currentBillingBranchId = this.defaultConditions.currentBillingBranchId
      }
      // 是否有应付受控费用权限
      const isControlled = this.$checkPermission(['button_Charge_controlled'])
      // 是否有应收受控费用权限
      const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
      let value = 0
      if (!isControlled && !isCostControlled) {
        value = 1
      } else if (!isControlled) {
        value = 2
      } else if (!isCostControlled) {
        value = 3
      }
      if (value !== 0) {
        const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }

      // 业务详情国内账单-加入费用
      let roleMap = {}
      if (this.defaultConditions.roleCreatedBy) {
        roleMap = { 'roleCreatedBy': this.defaultConditions.roleCreatedBy }
      }

      const requestBody = {
        conditions,
        roleMap,
        currentBillingBranchId: currentBillingBranchId,
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize,
        'requestSource': this.viewSource
      }
      getAddChargeList(requestBody).then(res => {
        this.rowData = res.data.list
        this.searchConditions.total = Number(res.data.total)
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(this.rowData)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }).finally(() => {
        this.loading.close()
      })
    },
    enterEvent() { // 确定事件
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectCharges'))
        return
      }
      let flag = false
      let statusFlag = false
      const statusData = []
      if (chooseRows && chooseRows.length > 0) {
        for (let i = 0; i < chooseRows.length; i++) {
          const charge = chooseRows[i]
          // 核销状态 - 全部核销
          if (charge['chargeAmount'] === charge['chargeVerifiedAmount'] && charge['chargeAmount'] !== 0) {
            flag = true
          } else {
            statusFlag = true
            statusData.push(charge)
          }
        }
        if (flag) {
          this.$confirm(this.$t('Message.SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            this.$emit('addChargeCallBackEvent', chooseRows)
          }).catch((action) => {
            if (action === 'close') {
              return
            } else {
              if (statusFlag) {
                this.$emit('addChargeCallBackEvent', statusData)
              } else {
                this.$message.warning(this.$t('Message.AllSelectedFeesWillBeVerifiedPleaseChooseAgain'))
                return
              }
            }
          })
        } else {
          this.$emit('addChargeCallBackEvent', chooseRows)
        }
      }
      // this.$emit('addChargeCallBackEvent', chooseRows)
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(event) {
      console.log('toRefreshSelectedCountChargeGrid', event)
      this.filterChange()
      // this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
    },
    filterChange() {
      this.selections = getGridSelected(this.gridOptions)
      if (this.selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, this.selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(selections)
        this.totalAmountToCurrencyChargeGrid.selectedCount = selections.length
      } else if (arg == 1) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvide = this.getChargeCountGroupDataProvider(selections)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvide = this.getChargeCountGroupDataProvider(this.rowData)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }
    },
    // 重新组装合计弹出框数据源
    getChargeCountGroupDataProvider(rowData = []) {
      const list = []
      if (rowData && rowData.length > 0) {
        for (const charge of rowData) {
          const map = {
            charge_currency: charge.chargeCurrency,
            charge_receivable: charge.chargeReceivable,
            charge_exchangeRate: charge.chargeExchangeRate,
            charge_amount: charge.chargeReceivable ? charge.chargeAmount * -1 : charge.chargeAmount
          }
          list.push(map)
        }
      }
      return list
    },
    toSearchTemplate(value) {
      this.$emit('toSearchTemplate', value)
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
